import { TableCellProps } from '@mui/material'
import { COLORS } from 'styles/colors'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
export const TABLE_HEAD = {
	rowKey: 'tableFatnessWidgetHead',
	rowBorderBottom: COLORS.secondaryFontOpacity,
	rowHeight: '20px',
	cellItems: [
		{
			padding: '0px 0px 4px 0px',
			width: '50%',
			children: <TypographySecondary>Категория</TypographySecondary>,
		},
		{
			padding: '0px 0px 4px 0px',
			width: '50%',
			children: <TypographySecondary>Количество голов</TypographySecondary>,
		},
		{
			padding: '0px 0px 4px 0px',
			width: '10%',
			children: <TypographySecondary>%</TypographySecondary>,
			align: 'right' as TableCellProps['align'],
		},
	],
}
